import { useBetslipStore } from "@/features/betslip/stores/betslipStore";

/**
 * Active selection count. Mirrors `useBetslipSelectionIds` for nav badges.
 */
export const useBetslipSelectionsCount = (): number =>
  useBetslipStore((s) => s.selectionsCount);
